import { render, staticRenderFns } from "./HomeCard.vue?vue&type=template&id=67537a0a&scoped=true"
import script from "./HomeCard.vue?vue&type=script&lang=js"
export * from "./HomeCard.vue?vue&type=script&lang=js"
import style0 from "./HomeCard.vue?vue&type=style&index=0&id=67537a0a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67537a0a",
  null
  
)

export default component.exports